module.exports = __webpack_public_path__ + "static/media/icon-event__revolucion-del-68-hover.2f632cdd.svg";